import { DataLoader } from '../../../core/types/data-loader';
import { StateStoreOrVoid } from '../../../core/types/application-state';
import { postFONASUContribLimits } from '../../shared/services/fonasu-ira-contribution-limits';
import { getCustomerHouseholdDataById } from '../../shared/services/household-service';
import { parseCurrentQueryString, withDefault } from '../../../core/util';
import { houseHoldSummitData } from '../../shared/summit.utils';
import { getCustomerDataById } from '../../shared/services/customer-service';
import { loadFONASUCustomerData } from '../shared/loaders';
import {
  consumerTypes,
  accountTypes,
  chargeTypes,
  fundingTypes,
  applicationStatusTypes
} from '../../shared/utils';
import { isMailingAddressDifferent } from '../shared/utils';

export enum IRAAccountTypes {
  TRADITIONAL = 'TRADITIONAL',
  ROTH = 'ROTH'
}

export type ToIRATypes = {
  toIRAAccountType: IRAAccountTypes;
};

export const makeLoadContributoryData = ({
  toIRAAccountType
}): DataLoader => async (): Promise<StateStoreOrVoid> => {
  const qs = parseCurrentQueryString();
  const { bpId } = qs;

  const householdData = await getCustomerHouseholdDataById(Number(bpId));

  const contributionLimits = await postFONASUContribLimits(Number(bpId));

  const summitData = houseHoldSummitData(householdData);

  const customerData = await getCustomerDataById(Number(bpId));
  const customerDataConverted = loadFONASUCustomerData(customerData);

  const mailingAddressDifferent = isMailingAddressDifferent(
    customerDataConverted
  );

  const usernameExists = !!customerData?.username?.length;

  return {
    app: {
      toIRAAccountType,
      applicationStatus: applicationStatusTypes.PUSH_TO_WEB,
      fundingType: fundingTypes.CHECK,
      chargeType: chargeTypes.NEW,
      customer: customerDataConverted,
      newInvestments: []
    },
    accountType: accountTypes.CONTRIBUTORY,
    mailingAddressDifferent,
    loadedData: {
      contributionLimits,
      infoValid: false,
      portfolioValid: false,
      usernameExists,
      loginID: withDefault(customerData?.username, ''),
      error: '',
      customerInfoEditMode: true,
      portfolioEditMode: false,
      currentYearAmount: '',
      priorYearAmount: '',
      associateLoginID: ''
    },
    summitData,
    consumerName: consumerTypes.FONASU,
    progressStep: 4,
    progressStepText:
      toIRAAccountType === IRAAccountTypes.ROTH ? '18e03f' : '21d7c7'
  };
};
